<template>
  <div>
    <Head title="Prüfungen fortsetzen"/>
    <h1 class="h1">Prüfungen fortsetzen</h1>
    <div class="flex items-center justify-between mb-6">
<!--      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">-->
<!--        <label class="block text-gray-700">Trashed:</label>-->
<!--        <select v-model="form.trashed" class="form-select mt-1 w-full">-->
<!--          <option :value="null"/>-->
<!--          <option value="with">With Trashed</option>-->
<!--          <option value="only">Only Trashed</option>-->
<!--        </select>-->
<!--      </search-filter>-->
      <!--      <Link class="btn-primary" href="/contacts/create">-->
      <!--        <span>Create</span>-->
      <!--        <span class="hidden lg:inline">&nbsp;Contact</span>-->
      <!--      </Link>-->
    </div>

    <test-item
        v-for="test in tests.data"
        :key="test.id"
        :test="test"
    />
    <div v-if="tests.data.length === 0">
      Du hast noch keine Prüfungen begonnen.
    </div>
    <pagination class="mt-6" :links="tests.links"/>
  </div>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Pagination,
    SearchFilter,
  },

  layout: Layout,

  props: {
    tests: Array,
  },

  mounted() {
    console.log(this.tests)
  },

  data() {
    return {
      form: {
        // search: this.filters.search,
        // trashed: this.filters.trashed,
      },
    }
  },

  methods: {
    reset() {
      // this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
